import React, { useCallback, useState } from 'react'
import { useEditor } from 'slate-react'
import { Dialog, DialogTitle, Icon, IconButton, makeStyles } from '@cicero/ui'
import { IDashboardElement, IDashboardWidgetElement, IEditorElementProps, IElementDefinition } from '../EditorService'
import { WidgetConfigForm } from '../widgets/config'
import { DashboardCommands } from '../commands'

export const DashboardElement = ({ children, attributes, element }: IEditorElementProps<IDashboardElement>) => {
  const { dashboardWrapper, dashboardAddNew } = useStyles()
  const [modalOpen, setModalOpen] = useState(false)
  const editor = useEditor()

  const addWidget = useCallback((widget: IDashboardWidgetElement) => {
    setModalOpen(false)
    DashboardCommands.addWidget(editor, element, widget)
  }, [modalOpen])

  return <div
    className={dashboardWrapper}
    contentEditable={false}
    {...attributes}
  >
    {children}
    <IconButton className={dashboardAddNew} onClick={() => setModalOpen(true)}><Icon fontSize="large">add</Icon></IconButton>
    <Dialog open={modalOpen} maxWidth="lg">
      <DialogTitle>Add a Widget</DialogTitle>
      { modalOpen ? <WidgetConfigForm onCancel={() => setModalOpen(false)} onSave={(widget) => addWidget(widget)} /> : null  }
    </Dialog>
  </div>
}

export const DashboardElementDef: IElementDefinition = {
  renderer(props) { return <DashboardElement {...props} /> },
}

const useStyles = makeStyles({
  dashboardWrapper: {
    alignItems: 'stretch',
    boxSizing: 'border-box',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    marginBottom: 16,
    width: '100',
    '& > *': {
      flexGrow: 1,
      margin: 6,
    },
  },
  dashboardAddNew: {
    border: '2px dashed #DDD',
    borderRadius: 4,
    display: 'flex',
    justifyContent: 'center',
    minWidth: '30%',
  },
})
